import { AppIdentifier } from "../@types/AppIdentifier";

export const getAppByPath = (route: string): AppIdentifier | undefined => {
  const [appId] = route.slice(1).split("/");

  switch (appId) {
    case "account":
      return AppIdentifier.Account;
    case "admin-control-center":
      return AppIdentifier.AdminControlCenter;
    case "dashboard":
      return AppIdentifier.Dashboard;
    case "fbs-hub":
      return AppIdentifier.FbsHub;
    case "finish-registration":
      return AppIdentifier.FinishRegistration;
    case "equivolt":
      return AppIdentifier.Equivolt;
    case "gas-shop":
      return AppIdentifier.GasShop;
    case "general-error":
      return AppIdentifier.GeneralError;
    case "login":
      return AppIdentifier.Login;
    case "maintenance":
      return AppIdentifier.Maintenance;
    case "registration":
      return AppIdentifier.Registration;
    case "thg-quote":
      return AppIdentifier.ThgQuote;
    case "wcc-management":
      return AppIdentifier.WccManagement;
    case "westfalen-id-account-management":
      return AppIdentifier.WestfalenIdAccountManagement;
    case "wsc-management":
      return AppIdentifier.WscManagement;
    default:
      return undefined;
  }
};
